// extracted by mini-css-extract-plugin
export default {"select":"SelectComponent_select__sW0qo","menuItemStyles":"SelectComponent_menuItemStyles__DmnQ3","inputStyles":"SelectComponent_inputStyles__JIrFq"};